import Checkbox from 'semantic-ui-react/dist/commonjs/modules/Checkbox';
import '@purple/semantic-ui-family-connection-theme/components/checkbox.css';

export default Checkbox;
